import EbdaEduNavbar from "components/navbars/EbdaEduNavbar";
import { useEffect, useState } from "react";
import { fetchEmployeePerformaceReport, fetchWatomsRelatedVtcs } from "services/watoms/watomsData";

const EbdaEduWatomsVtcPerformanceReport = () => {
    const [selectedDay, setSelectedDay] = useState("");
    const [selectedVtc, setSelectedVtc] = useState("");
    const [vtcs, setVtcs] = useState([]);
    const [prReportData, setPrReportData] = useState([]);
    const [unfilteredPrReportData, setUnfilteredPrReportData] = useState([]);

    useEffect(() => {
        const loadVtcs = async () => {
            const response = await fetchWatomsRelatedVtcs();
            setVtcs(response);
        }

        const loadEmployeesPerformanceReports = async () => {
            const response = await fetchEmployeePerformaceReport();
            setPrReportData(response);
            setUnfilteredPrReportData(response);
        }

        loadVtcs();
        loadEmployeesPerformanceReports();
    }, []);

    useEffect(() => {
        const filterPRData = () => {

            let filtered = unfilteredPrReportData;

            if (selectedVtc !== "") {
                filtered = filtered.filter(
                    report => report.user.employee.organization_id === Number(selectedVtc)
                );
            }

            if (selectedDay !== "") {
                filtered = filtered.filter(report => {
                    const createdDate = new Date(report.createdAt).toISOString().split("T")[0];
                    return createdDate === selectedDay;
                });
            }

            setPrReportData(filtered);
        };

        filterPRData();
    }, [selectedVtc, selectedDay, unfilteredPrReportData]);

    return (
        <div>
            <EbdaEduNavbar />
            <div className="w-full h-full bg-white p-4 flex flex-col items-center overflow-y-auto">
                <h2 className="text-2xl text-end font-bold text-gray-800">
                    تقارير الأداء
                </h2>
                <div className="flex justify-center items-center gap-4 py-2">
                    <div className="flex flex-col justify-center">
                        <label className="text-center">:اليوم</label>
                        <input
                            className="w-60 p-3 bg-gray-200 rounded"
                            type="date"
                            value={selectedDay}
                            onChange={(e) => setSelectedDay(e.target.value)}
                        />
                    </div>
                    <div className="flex flex-col justify-center">
                        <label className="text-center">:المركز</label>
                        <select
                            id="vtc"
                            name="vtc"
                            onChange={(e) => setSelectedVtc(e.target.value)}
                            value={selectedVtc}
                            dir="rtl"
                            className="bg-gray-200"
                        >
                            <option value="" disabled selected>
                                الرجاء اختيار المركز
                            </option>
                            {vtcs.map((s) => (
                                <option key={s.id} value={s.id}>
                                    {s.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                {selectedVtc !== "" && selectedDay !== "" && <table className="w-full text-right border-collapse overflow-hidden rounded-lg shadow" dir="rtl">
                    <thead>
                        <tr className="bg-blue-600 text-white">

                            {/* Fixed first column */}
                            <th
                                className="text-center p-3"
                                style={{ width: `${100 / (prReportData.length + 1)}%` }}
                            >
                                العنوان
                            </th>

                            {/* Dynamic employee columns */}
                            {prReportData.map((obj, index) => (
                                <th
                                    key={index}
                                    className="text-center p-3"
                                    style={{ width: `${100 / (prReportData.length + 1)}%` }}
                                >
                                    {`${obj.user?.employee?.first_name} ${obj.user?.employee?.middle_name} ${obj.user?.employee?.last_name}`}
                                </th>
                            ))}

                        </tr>
                    </thead>

                    <tbody className="text-gray-700">

                        {/* --- ايام العمل المقررة --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">ايام العمل المقررة</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.planned_working_days ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- ايام الحضور الفعلي --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">ايام الحضور الفعلي</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.actual_working_days ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- عدد ايام الغياب --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">عدد ايام الغياب</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.absence_days ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- عدد مرات التأخير --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">عدد مرات التأخير</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.no_of_latness ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- عدد ايام الانصراف المبكر --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">عدد ايام الانصراف المبكر</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.no_of_early_leave ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- ملاحظة --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">ملاحظة</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.notes !== "" ? obj.notes : "لا يوجد"}
                                </td>
                            ))}
                        </tr>

                        {/* --- التعاون والعمل الجماعي --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">التعاون والعمل الجماعي</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.score_one ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- الالتزام بالتعليمات --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">الالتزام بالتعليمات</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.score_two ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- مستوى المبادرة --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">مستوى المبادرة</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.score_three ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- القدرة على حل المشكلات --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">القدرة على حل المشكلات</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.score_four ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- إدارة الوقت وتنظيم العمل --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">إدارة الوقت وتنظيم العمل</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.score_five ?? 0}
                                </td>
                            ))}
                        </tr>

                        {/* --- مهارات التواصل --- */}
                        <tr className="odd:bg-gray-100 even:bg-white border-b">
                            <td className="font-medium text-center p-3">مهارات التواصل</td>
                            {prReportData.map((obj, index) => (
                                <td key={index} className="text-center p-3">
                                    {obj.score_six ?? 0}
                                </td>
                            ))}
                        </tr>

                    </tbody>
                </table>}
            </div>
        </div>
    )
};

export default EbdaEduWatomsVtcPerformanceReport;